import script from "./payment_method - 副本.vue?vue&type=script&setup=true&lang=js"
export * from "./payment_method - 副本.vue?vue&type=script&setup=true&lang=js"

import "./payment_method - 副本.vue?vue&type=style&index=0&id=0edc3f0a&lang=less"

const __exports__ = script;

export default __exports__